/**
 *
 * This file contains a React component called GetScript that retrieves script details for a hunt.
 * It uses state hooks to manage the script data, updating status, and modal visibility.
 * When the component mounts, it sends a GET request to the server to retrieve the script data.
 * The retrieved data is then displayed in a modal window.
 * The component also includes PropTypes for title and ID.
 *
 */

import React, { useContext, useState, useEffect } from 'react'
import HostLoginWrapper from '../../components/host/login-wrapper'
import HostContext from '../../utils/host-context'
import API from '../../utils/api'
import SvgArrow from '../../components/svg/arrow'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/Modal'

const GetScript = ({ title, ID }) => {
  const [ScriptData, setScriptData] = useState({})
  const [updating, setUpdating] = useState(false)
  const [modalShow, setModalShow] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  const modalClose = () => {
    setModalShow(false)
  }

  const getScriptContent = () => {
    setModalShow(true)
    setIsMounted(true)
  }

  useEffect(() => {
    if (isMounted) {
      setUpdating(true)
      API.get(`/host/script/${ID}/`, {
        headers: {
          Authorization: `JWT ${localStorage.getItem(`token`)}`,
        },
      }).then(res => {
        console.log(res)
        setScriptData(res.data)
        setUpdating(false)
      })
    }
  }, [isMounted])

  return (
    <>
      <button
        className="h4"
        style={{
          backgroundColor: `transparent`,
          border: `none`,
        }}
        onClick={getScriptContent}>
        {!updating ? <>{title}</> : <>Loading...</>}
      </button>
      <Modal show={modalShow} onHide={modalClose} centered scrollable={true} aria-labelledby="View script">
        <Modal.Header className={`card-header`} closeButton>
          <Modal.Title id="progress-modal-title" className={`card-title mb-2`}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`card-body bg-white text-dark`}>
          <>
            {updating && <p>Loading...</p>}
            {ScriptData && ScriptData.content && <div dangerouslySetInnerHTML={{ __html: ScriptData.content }} />}
            {ScriptData && ScriptData.file_url && (
              <a className="btn btn-primary mt-4 w-100" href={ScriptData.file_url} target="_blank" rel="noreferrer">
                Download file
              </a>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          <button className={`btn btn-block btn-tiny mt-4`} onClick={modalClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default GetScript

GetScript.propTypes = {
  title: PropTypes.string,
  ID: PropTypes.number,
}
